import BaseComponentV2 from "../../../../../../library/js/components/base-component-v2";
/**
 * Creates a GoogleMap with 2 markers and draws the route on the map and places it on the DOM.
 */
export default class DirectionsMapComponent extends BaseComponentV2 {

  /**
   * @param $element jQuery element.
   */
  constructor($element) {

    super($element);

    this.element.hide();

    this.directionsService = new google.maps.DirectionsService();
    this.directionsDisplay = new google.maps.DirectionsRenderer();

    const map = new google.maps.Map(this.element[0], {
      zoom: 7,
      center: {lat: 41.85, lng: -87.65},
      disableDefaultUI: true,
      zoomControl: true,
      scaleControl: true
    });

    this.directionsDisplay.setMap(map);
  }

  /**
   * Automatically configure component based on DOM element attributes.
   */
  autoSet() {

    this.origin = this.getData('origin-address');
    this.destination = this.getData('destination-address');
    this.render();
  }

  /**
   * Set the origin address.
   *
   * @param {string} address
   */
  setOrigin(address) {

    this.origin = address;
  }

  /**
   * Set the destination address.
   *
   * @param {string} address
   */
  setDestination(address) {

    this.destination = address;
  }

  render() {

    this.directionsService.route({
      origin: this.origin,
      destination: this.destination,
      travelMode: 'DRIVING'

    }, (response, status) => {

      if (status === 'OK') {
        this.directionsDisplay.setDirections(response);
        this.element.show();

      } else {
        window.alert('Directions request failed due to ' + status);
      }
    });

  }
}
